import React from 'react';

type BrandLogoProps = {
  className?: string;
  iconClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
};

export const BrandLogo: React.FC<BrandLogoProps> = ({
  className = '',
  iconClassName = '',
  titleClassName = '',
  subtitleClassName = '',
}) => {
  return (
    <a
      href="/"
      className={`group inline-flex items-center gap-3 transition-opacity hover:opacity-90 ${className}`.trim()}
      aria-label="返回首页"
    >
      <span
        className={`flex h-11 w-11 items-center justify-center overflow-hidden rounded-full border border-[#FFC000]/35 bg-white shadow-[0_0_28px_rgba(255,192,0,0.12)] ${iconClassName}`.trim()}
      >
        <img
          src="https://oss.biubbmk.cn/public/9df41181-94ff-4d69-af8d-6980884d073f.jpg"
          alt="元 YUAN 标志"
          className="h-full w-full object-cover"
        />
      </span>

      <span className="flex flex-col leading-none">
        <span
          className={`font-['Noto_Serif_SC','Songti_SC',serif] text-xl font-semibold tracking-[0.18em] text-[#FFC000] sm:text-2xl ${titleClassName}`.trim()}
        >
          元
        </span>
        <span
          className={`mt-1 text-[10px] uppercase tracking-[0.42em] text-white/70 sm:text-[11px] ${subtitleClassName}`.trim()}
        >
          YUAN
        </span>
      </span>
    </a>
  );
};

export default BrandLogo;
